export default "__VITE_ASSET__7903cfb8__"